<template>
	<div class="d-flex flex-column h-100" style="padding-top: 75px;">
		<LayoutHeaderMain :fixed="true" />
		<main class="flex-fill d-flex flex-column">
			<router-view v-slot="{ Component }">
				<transition name="route" mode="out-in">
					<component :is="Component" />
				</transition>
			</router-view>
		</main>
		<CustomerModalOption />
		<CustomerModalContact />
		<CustomerModalContacted />
		<CustomerModalProposed />
		<CustomerModalStatus />
	</div>
</template>